import { render, staticRenderFns } from "./ComboboxPagination.vue?vue&type=template&id=0a52fa01&"
import script from "./ComboboxPagination.vue?vue&type=script&lang=ts&"
export * from "./ComboboxPagination.vue?vue&type=script&lang=ts&"
import style0 from "./ComboboxPagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports